<template>
  <div id="arrMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>停车场</el-breadcrumb-item>
          <el-breadcrumb-item>路侧场库设置</el-breadcrumb-item>
          <el-breadcrumb-item>欠费补缴管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px"
             id="search">
      <el-row>
        <el-col :span="24">
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="datetime"
                            :clearable="false"
                            format="yyyy-MM-dd HH:mm"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            format="yyyy-MM-dd HH:mm"
                            type="datetime"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="loadPark"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fInParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌::">
            <el-input placeholder="请输入车牌"
                      v-model="pageSearch.searchKeyWord"
                      class="search">
              <!-- <i slot="prefix"
               class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-download"
                       :loading="export_loading"
                       @click="createTemplate"
                       v-if="is_import">创建模板</el-button>
            <el-button type="warning"
                       icon="el-icon-upload"
                       size="small"
                       v-if="is_import"
                       @click="importData">导入</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  :summary-method="getSummaries"
                  show-summary
                  ref="dt"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fInTime"
                           width="160"
                           label="进场时间">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌号码">
          </el-table-column>
          <el-table-column prop="fPlateColor"
                           width="75"
                           label="车牌颜色">
          </el-table-column>
          <el-table-column prop="fIsCard"
                           width="80"
                           label="是否月车">
          </el-table-column>
          <el-table-column prop="fParkName"
                           label="进场场库">
          </el-table-column>
          <el-table-column prop="fCarNumber"
                           width="75"
                           label="车位编号">
          </el-table-column>
          <el-table-column prop="fOutTime"
                           width="160"
                           label="出场时间">
          </el-table-column>
          <!-- <el-table-column prop="fOutChnlName"
                           label="出场通道">
          </el-table-column> -->
          <!--<el-table-column prop="fPaySecs"-->
          <!--width="100"-->
          <!--label="计费时间">-->
          <!--</el-table-column>-->
          <el-table-column prop="fRateGroupName"
                           label="计费费率">
          </el-table-column>
          <el-table-column prop="fCalcAmt"
                           width="100"
                           align="right"
                           label="计费金额">
          </el-table-column>
          <el-table-column prop="fDedAmt"
                           width="75"
                           align="right"
                           label="抵扣金额">
          </el-table-column>
          <el-table-column prop="fPayAmt"
                           align="right"
                           width="100"
                           label="欠费金额">
          </el-table-column>
          <el-table-column prop="fPayStatus"
                           width="75"
                           label="支付状态">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="355">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_editAmt"
                         @click="handlepay(scope.$index, scope.row)">修改金额</el-button>
              <el-button size="mini"
                         type="info"
                         v-if="is_edit"
                         @click="appearanceShow(scope.$index, scope.row)">正常出场</el-button>
              <el-button size="mini"
                         type="danger"
                         v-if="is_del"
                         @click="deleteArrClient(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="导入欠费记录"
               :visible.sync="importDataVisible"
               width="65%"
               top="7vh"
               v-dialogDrag>
      <el-form label-width="120px"
               :inline="true">
        <el-row>
          <el-form-item label="选择客户::">
            <el-select v-model="importModel.fCustID"
                       style="width:250px"
                       filterable
                       @change="changeImportCust"
                       :disabled="importModel.btnOkLoading||importModel.btnLoading"
                       placeholder="请选择::">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择场库::">
            <el-select v-model="importModel.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:250px;"
                       clearable>
              <el-option v-for="item in arrpark_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="导入excel文件::"
                        style="height:65px">
            <el-upload class="upload-demo"
                       action="#"
                       :show-file-list='false'
                       :on-success="uploadSuccess"
                       :http-request="uploadExcel">
              <el-button size="small"
                         type="primary"
                         :disabled="importModel.btnOkLoading"
                         :loading="importModel.btnLoading">{{importModel.btnMsg}}</el-button>
              <div slot="tip"
                   class="el-upload__tip">只能上传Excel文件</div>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table :data="importModel.data"
                      :row-class-name="tableErrorRowClassName"
                      border
                      v-loading="importModel.loading"
                      highlight-current-row
                      style="width: 100%"
                      height="400">
              <el-table-column prop="num"
                               width="50"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fCustNo"
                               label="客户编号">
              </el-table-column>
              <el-table-column prop="fCustName"
                               label="客户名称">
              </el-table-column>
              <el-table-column prop="fParkName"
                               label="场库名称">
              </el-table-column>
              <el-table-column prop="fPlateCode"
                               label="车牌">
              </el-table-column>
              <el-table-column prop="fInTimeStr"
                               label="进场时间">
              </el-table-column>
              <el-table-column prop="fOutTimeStr"
                               label="出场时间">
              </el-table-column>
              <el-table-column prop="fPayAmtStr"
                               label="欠费金额">
              </el-table-column>
              <el-table-column label="错误信息"
                               fixed="right">
                <template slot-scope="scope">
                  <el-tooltip placement="left">
                    <div slot="content"
                         v-html="scope.row.fErrorMsg"></div>
                    <span>{{scope.row.fErrorMsg}}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled="importModel.btnOkDisabled"
                   @click="importOk"
                   :loading="importModel.btnOkLoading">{{importModel.btnOkMsg}}</el-button>
        <el-button @click="importDataVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改金额"
               :visible.sync="arrVisible"
               v-dialogDrag
               top="7vh"
               left="0vh"
               width="500px">
      <el-form :model="arrObj"
               :rules="arrRules"
               ref="arrform"
               label-width="120px">
        <el-row>
          <el-col>
            <el-form-item label="车牌::"
                          prop="fPlateCode">
              <el-input v-model="arrObj.fPlateCode"
                        autocomplete="off"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="补缴金额(元)::"
                          prop="fPayAmtMoney">
              <el-input v-model="arrObj.fPayAmtMoney"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:right">
        <el-button type="primary"
                   @click="submitArrPay('arrform')">保存</el-button>
        <el-button @click="arrVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="appDialogTitle"
               id="appDialog"
               :visible.sync="appDialogVisible"
               v-dialogDrag
               top="7vh"
               left="0vh">
      <el-form :model="appModel"
               :rules="appRules"
               ref="appform"
               label-width="120px">
        <el-row>
          <el-col :span="24">
            <span style="color:red;">注:选中的支付记录字体为红色，若有选中记录则会修改选中的支付记录，否则会新增一条支付记录</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table :data="payData"
                      ref="singleTable"
                      v-loading="payLoading"
                      highlight-current-row
                      @row-click="rowClick"
                      height="200px"
                      border
                      stripe
                      style="width: 100%">
              <el-table-column prop="fRowNumber"
                               width="50"
                               label="序号">
              </el-table-column>
              <el-table-column prop="fPayTime"
                               width="160"
                               label="时间">
              </el-table-column>
              <el-table-column prop="fPayment"
                               width="200"
                               label="支付方式">
              </el-table-column>
              <el-table-column prop="fBusOrderNo"
                               width="120"
                               label="商户订单号">
              </el-table-column>
              <el-table-column prop="fPayAmount"
                               align="right"
                               width="120"
                               label="支付金额">
              </el-table-column>
              <el-table-column prop="fRemark"
                               label="备注">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row style="padding-top:10px">
          <el-col :span="24">
            <el-form-item label="操作员::"
                          prop="fOpUserID">
              <el-select v-model="appModel.fOpUserID"
                         style="width:220px;"
                         filterable
                         placeholder="请选择设备">
                <el-option v-for="item in devacc_list"
                           :key="item.fDevAccID"
                           :label="item.fDevAccNo+':'+item.fLinkman"
                           :value="item.fDevAccID">
                  <!-- <span style="float: left">{{ item.fDevAccNo }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.fLinkman }}</span> -->
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出场时间:"
                          prop="fOutTime">
              <el-date-picker v-model="appModel.fOutTime"
                              :clearable="false"
                              type="datetime"
                              placeholder="选择出场时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付方式::"
                          prop="fPayTypeID">
              <el-select v-model="appModel.fPayTypeID"
                         style="width:220px;"
                         filterable
                         placeholder="请选择支付方式">
                <el-option v-for="(e, i) in payType_list"
                           :key="i"
                           :label="e.fOuterName"
                           :value="e.fPayTypeID">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商户订单号:"
                          prop="fBusOrderNo">
              <el-input v-model="appModel.fBusOrderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付授权码:"
                          prop="fPayCode">
              <el-input v-model="appModel.fPayCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="实际支付金额:"
                          prop="fPayAmount">
              <el-input v-model="appModel.fPayAmount"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:right">
        <el-button type="primary"
                   :loading="appLoading"
                   @click="submitAppEdit('appform')">{{appSave_Title}}</el-button>
        <el-button @click="appDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <roadSideCarInfoView ref="child"
                         :type="4"></roadSideCarInfoView>
  </div>
</template>

<script>
import roadSideCarInfoView from '../../components/roadSideCarInfoView'
import { report as api } from '../../api/roadSideReport'
import * as park from '../../api/park'
import * as user from '../../api/user'
import { cust as apiCust } from '../../api/cust'
import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  components: { roadSideCarInfoView },
  data () {
    var validateMoney = (rule, value, callback) => {
      if (!/^([0-9][0-9]*)+(\.[0-9]{1,2})?$/.test(value)) {
        callback(new Error('请输入正确的金额'))
      }
      callback()
    }
    var validateNum = (rule, value, callback) => {
      if (!/^([0-9][0-9]*)+(\.[0-9]{1,2})?$/.test(value)) {
        callback(new Error('请输入正确的支付金额'))
      }
      callback()
    }
    return {
      arrObj: {
        fPayAmtMoney: '',
        fOldPayAmtMoney: ''
      },
      arrRules: {
        fPayAmtMoney: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' }
        ]
      },
      appRules: {
        fOpUserID: [
          { required: true, message: '请选择设备', trigger: 'change' }
        ],
        fOutTime: [
          { required: true, message: '请选择出场时间', trigger: 'blur' }
        ],
        fPayTypeID: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        fPayAmount: [
          { required: true, message: '请输入支付金额', trigger: 'blur' },
          { validator: validateNum, trigger: 'blur' }
        ]
      },
      currentRow: {},
      total: {},
      payLoading: false,
      appSave_Title: '保存',
      payData: [],
      devacc_list: [],
      payType_list: [],
      appLoading: false,
      appModel: {
        fBigRowID: '',
        fPayBigRowID: '',
        fPayTypeID: '',
        fOpUserID: '',
        fBusOrderNo: '',
        fPayCode: '',
        fOutTime: '',
        fPayAmount: ''
      },
      appDialogTitle: '',
      appDialogVisible: false,
      arrVisible: false,
      importDataVisible: false,
      importModel: {
        fCustID: '',
        fParkID: '',
        data: [],
        loading: false,
        btnMsg: '点击上传',
        btnLoading: false,
        btnOkDisabled: true,
        btnOkMsg: '确定导入',
        btnOkLoading: false
      },
      is_export: false,
      is_import: false,
      is_edit: false,
      is_del: false,
      is_editAmt: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      park_list: [],
      arrpark_list: [],
      pageCount: 0,
      startTime: '',
      endTime: '',
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fInParkID: '',
        isError: false,
        // type: 0,
        fstartTime: '',
        fendTime: '',
        searchKeyWord: ''
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      api.arrMainList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
            this.total = data.Data.total
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            this.$message.error('提示：欠费数据加载失败')
          }
        }
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fInParkID = ''
      this.park_list = []

      // 加载离场数据列表
      // this.page_list()

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    rowClick (row, column, event) {
      if (this.currentRow === row) {
        this.currentRow = undefined
        this.$refs.singleTable.setCurrentRow(this.currentRow)
        this.appModel.fPayBigRowID = ''
      } else {
        this.currentRow = row
        this.appModel.fPayBigRowID = row.fBigRowID
        this.appModel.fBusOrderNo = row.fBusOrderNo
        this.appModel.fPayCode = row.fPayCode
        this.appModel.fPayTypeID = row.fPayTypeID
        this.appModel.fOpUserID = row.fOpUserID
        this.appModel.fPayAmount = parseFloat(row.fPayAmt)
      }
    },
    changePark () {
      // 加载离场数据列表
      this.page_list()
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      for (let index = 0; index < 14; index++) {
        if (index === 1) {
          sums[index] = '合计'
        } else if (index === 10) {
          sums[index] = this.total.fCalcAmt
        } else if (index === 11) {
          sums[index] = this.total.fDedAmt
        } else if (index === 12) {
          sums[index] = this.total.fPayAmt
        } else {
          sums[index] = ''
        }
      }
      return sums
    },
    uploadSuccess (response, file, fileList) {
      console.log('file upload success')
    },
    changeImportCust (fCustID) {
      this.importModel.data = []
      this.importModel.btnOkDisabled = true

      this.importModel.fParkID = ''
      this.arrpark_list = []

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.arrpark_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    uploadExcel (file) {
      if ((this.importModel.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户!')
        return
      }
      if ((this.importModel.fParkID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择场库!')
        return
      }
      var exts = ['.xls', '.xlsx']
      var fileExt = file.file.name.substring(file.file.name.lastIndexOf('.')).toLowerCase()
      const isJPG = exts.indexOf(fileExt) !== -1
      const isLt500k = file.file.size / 1024 < 500

      if (!isJPG) {
        this.$message.error('提示：上传文件只能是 xls/xlsx 格式!')
        return
      }
      if (!isLt500k) {
        this.$message.error('提示：上传图片大小不能超过 500KB!')
        return
      }
      this.importModel.btnOkDisabled = true
      this.importModel.data = []
      this.importModel.loading = true
      this.importModel.btnLoading = true
      this.importModel.btnMsg = '导入中……'
      let data = new FormData()
      data.append('cradFile', file.file)
      data.append('fCustID', this.importModel.fCustID)
      data.append('fParkID', this.importModel.fParkID)
      api.uploadArrData(data).then(res => {
        // this.importModel.custDisabled = false
        this.importModel.btnLoading = false
        this.importModel.btnMsg = '点击上传'
        this.importModel.loading = false
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            var importData = data.Data || []
            this.importModel.data = importData
            if (importData.filter(r => r.fIsErr === false).length > 0) {
              this.importModel.btnOkDisabled = false
            }
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    importData () {
      if (this.importModel.btnMsg !== '导入中……' && this.importModel.btnOkMsg !== '导入中……') {
        this.importModel.fCustID = ''
        this.importModel.data = []
        this.importModel.btnOkDisabled = true
      }
      this.importDataVisible = true
    },
    importOk () {
      var data = this.importModel.data.filter(r => r.fIsErr === false)
      this.importModel.btnOkLoading = true
      this.importModel.btnOkMsg = '导入中……'
      api.importArrData({ fCustID: this.importModel.fCustID, fParkID: this.importModel.fParkID, data: data }).then(res => {
        this.importModel.btnOkLoading = false
        this.importModel.btnOkMsg = '确定导入'
        this.importModel.btnOkDisabled = true
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            this.$message({
              type: 'success',
              message: data.Msg
            })
            this.page_list()
            if (data.Data.length > 0) {
              this.importModel.data = data.Data
            } else {
              this.importDataVisible = false
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    deleteArrClient (index, row) {
      this.$confirm('删除该车牌[' + row.fPlateCode + ']的补缴记录, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.deleteArr(row).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.page_list()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    createTemplate () {
      api.createArrTemplate().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, '欠费导入模板.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.pageSearch.fstartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fendTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      api.arrMainListExport(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_欠费数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    tableErrorRowClassName ({ row, rowIndex }) {
      if (row.fIsErr) {
        return 'error-row'
      }
      return ''
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    accAdd (arg1, arg2) {
      var r1, r2, m, c
      try {
        r1 = arg1.toString().split('.')[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = arg2.toString().split('.')[1].length
      } catch (e) {
        r2 = 0
      }
      c = Math.abs(r1 - r2)
      m = Math.pow(10, Math.max(r1, r2))
      if (c > 0) {
        var cm = Math.pow(10, c)
        if (r1 > r2) {
          arg1 = Number(arg1.toString().replace('.', ''))
          arg2 = Number(arg2.toString().replace('.', '')) * cm
        } else {
          arg1 = Number(arg1.toString().replace('.', '')) * cm
          arg2 = Number(arg2.toString().replace('.', ''))
        }
      } else {
        arg1 = Number(arg1.toString().replace('.', ''))
        arg2 = Number(arg2.toString().replace('.', ''))
      }
      return (arg1 + arg2) / m
    },
    submitAppEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.appModel.fOutTime instanceof Date) {
            this.appModel.fOutTime = this.$dateFormat(this.appModel.fOutTime, 'yyyy-MM-dd hh:mm:ss')
          }
          var sumMoney = 0
          var payData = this.payData || []
          if ((this.appModel.fPayBigRowID || '').length > 0) {
            // 修改
            for (let i = 0; i < payData.length; i++) {
              if (payData[i].fBigRowID === this.appModel.fPayBigRowID) {
                sumMoney = this.accAdd(sumMoney, parseFloat(this.appModel.fPayAmount))
              } else {
                sumMoney = this.accAdd(sumMoney, parseFloat(payData[i].fPayAmt))
              }
            }
            if (parseFloat(this.appModel.fPayAmount) !== sumMoney) {
              this.$message.error('总支付金额与支付记录总和不等，无法修改；请核查后，进行保存！')
              return
            }
          } else {
            // 新增
            for (let i = 0; i < payData.length; i++) {
              sumMoney = this.accAdd(sumMoney, parseFloat(payData[i].fPayAmt))
            }
            sumMoney = this.accAdd(sumMoney, parseFloat(this.appModel.fPayAmount))
            if (parseFloat(this.appModel.fPayAmount) !== sumMoney) {
              this.$message.error('总支付金额与支付记录总和不等，无法修改；请核查后，进行保存！')
              return
            }
          }
          this.payLoading = true
          this.appSave_Title = '保存中…'
          api.arrNormalAppearance(this.appModel).then(res => {
            this.appSave_Title = '保存'
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.appDialogVisible = false
                this.page_list()
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }
      })
    },
    submitArrPay (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var row = this.arrObj
          if (parseFloat(this.arrObj.fPayAmtMoney) !== parseFloat(this.arrObj.fOldPayAmtMoney)) {
            row.fInRemark = '原欠费金额:' + this.arrObj.fOldPayAmtMoney + '修改后的欠费金额:' + this.arrObj.fPayAmtMoney
          }
          api.editArrAmt(row).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.arrVisible = false
                this.page_list()
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }
      })
    },
    appearanceShow (index, row) {
      this.appDialogTitle = '【' + row.fParkName + '】' + row.fPlateCode
      this.appModel = {
        fBigRowID: row.fBigRowID,
        fPayBigRowID: '',
        fPayTypeID: '',
        fOpUserID: row.fOpUserID,
        fBusOrderNo: '',
        fPayCode: '',
        fOutTime: row.fOutTime,
        fPayAmount: parseFloat(row.fPayAmtMoney)
      }
      setTimeout(() => {
        if (this.$refs['appform']) {
          this.$refs['appform'].clearValidate()
        }
      }, 50)
      this.devacc_list = []
      api.pdaList({ fCustID: row.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.devacc_list = data.Data || []
          } else {
            this.$message.error('提示：加载设备账号列表失败')
          }
        }
      })
      this.payLoading = true
      api.carBusPayAmountInfo({ fCustID: row.fCustID, fBusID: row.fBusID }).then(res => {
        if (res && res.data) {
          this.payLoading = false
          var data = res.data
          if (data.IsOk) {
            this.payData = data.Data || []
          } else {
            this.$message.error('提示：加载支付明细列表失败')
          }
        }
      })
      this.appDialogVisible = true
    },
    handlearrpay (index, arrrow) {
      Object.assign(this.arrObj, arrrow)
      this.arrObj.fPayAmtMoney = parseFloat(this.arrObj.fPayAmtMoney).toFixed(2)
      this.arrObj.fOldPayAmtMoney = this.arrObj.fPayAmtMoney
      if (parseFloat(this.arrObj.fPayAmtMoney) < 0) {
        this.$message({
          type: 'success',
          message: '补缴金额不能小于0'
        })
        return
      }
      this.$confirm('请确认是否补缴[车牌:' + this.arrObj.fPlateCode + ' 进场时间:' + this.arrObj.fInTime + ' 出场时间:' + this.arrObj.fOutTime + ']欠费记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.arrPay(this.arrObj).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.page_list()
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    handlepay (index, row) {
      if (this.$refs['arrform']) {
        this.$refs['arrform'].resetFields()
      }
      this.arrVisible = true
      Object.assign(this.arrObj, row)
      this.arrObj.fPayAmtMoney = parseFloat(this.arrObj.fPayAmtMoney).toFixed(2)
      this.arrObj.fOldPayAmtMoney = this.arrObj.fPayAmtMoney
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 246
      obj.tableHeight = clientHeight
      this.setImgHeight()
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 83000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
            this.is_import = data.Data.data.is_import
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_editAmt = data.Data.data.is_editAmt
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    apiCust.allPayType().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.payType_list = data.Data || []
        } else {
          this.$message.error('提示：加载支付方式失败')
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
/* dialog弹出框样式 */
#arrMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#arrMain .el-dialog__title {
  color: white;
}
#arrMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#arrMain .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
/* 文本框样式 */
#arrMain .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#arrMain .el-input.is-disabled .el-input__inner,
#arrMain .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#arrMain .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
#arrMain .el-input__icon {
  line-height: 32px;
}
#arrMain #appDialog .current-row td {
  color: red;
}
/* end */
</style>
<style scoped>
#search .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/arrMain.vue